export const fetchAvailableDashboard = resp => {
  return {
    type: "FETCH_DASHBOARDS_LIST",
    payload: resp
  };
};
export const setDashboardSelectedItem = selected => {
  return {
    type: "SET_DASHBOARDS_SELECTED_ITEM",
    selected
  };
};
export const setDashboardListPaginationPage = pageNumber => {
  return {
    type: "SET_DASHBOARDS_LIST_PAGINATION_PAGE",
    pageNumber
  };
};
export const setDashboardListPageSize = pageSize => {
  return {
    type: "SET_DASHBOARDS_LIST_PAGE_SIZE",
    pageSize
  };
};

export const setDashboardListFilterTitle = title => {
  return {
    type: "SET_DASHBOARDS_LIST_FILTER_TITLE",
    title
  };
};

export const setDashboardListFilterStatus = status => {
  return {
    type: "SET_DASHBOARDS_LIST_FILTER_STATUS",
    status
  };
};
export const setDashboardListFilterJuridicalForm = legalForms => {
  return {
    type: "SET_DASHBOARDS_LIST_FILTER_JURIDICAL_FORM",
    legalForms
  };
};

export const setDashboardListFilterisPublic = (isPublic, operator) => {
  return {
    type: "SET_DASHBOARD_LIST_FILTER_IS_PUBLIC",
    isPublic,
    operator
  };
};
export const setDashboardListFilter = filterStatus => {
  return {
    type: "SET_DASHBOARD_LIST_FILTER",
    filterStatus
  };
};
export const setDashboardListFilterNewDashboardIds = newDashboardIds => {
  return {
    type: "SET_DASHBOARD_LIST_FILTER_NEW_DASHBOARD_IDS",
    newDashboardIds
  };
};
export const setDashboardJuridicalFormSuggestions = payload => {
  return {
    type: "FETCH_DASHBOARDS_JURIDICAL_FORM_SUGGESTIONS",
    payload
  };
};
export const deleteDashboard = resp => {
  return {
    type: "DELETE_DASHBOARD",
    payload: resp
  };
};

export const duplicateDashboard = resp => {
  return {
    type: "DUPLICATE_DASHBOARD",
    payload: resp
  };
};

export const changePrivacyDashboard = resp => {
  return {
    type: "CHANGE_PRIVACY_DASHBOARD",
    payload: resp
  };
};

export const changeStateDashboard = resp => {
  return {
    type: "CHANGE_STATE_DASHBOARD",
    payload: resp
  };
};

export const setDashboardPrivate = resp => {
  return {
    type: "SET_DASHBOARD_PRIVATE",
    payload: resp
  };
};

export const useSharedDashboard = resp => {
  return {
    type: "USE_SHARED_DASHBOARD",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/dashboardList.js